import { useMemo } from "react";
import { funnelChart } from "utils/constants";

interface FunnelItem {
  etapa: string;
  gerado: number;
  abandono: number;
  abandono_total: number;
}

interface BudgetItem {
  _id: {
    Screen: string;
  };
  accumulated: number;
  abandonment_total: number;
  abandonment_rate: number;
}

export function useFunnelData(dashboardData?: { budgetsByDateRange: BudgetItem[] }) {
  const funnelData = useMemo<FunnelItem[]>(() => {
    if (!dashboardData?.budgetsByDateRange) return [];

    const dataMap = dashboardData.budgetsByDateRange.reduce<Record<string, BudgetItem>>(
      (acc, item) => {
        if (item._id?.Screen) acc[item._id.Screen] = item;
        return acc;
      },
      {}
    );

    return funnelChart.map(item => {
      const data = dataMap[item.screen];
      return {
        etapa: item.label,
        gerado: data?.accumulated ?? 0,
        abandono: data?.abandonment_rate ?? 0,
        abandono_total: data?.abandonment_total ?? 0,
      };
    });
  }, [dashboardData]);

  return funnelData;
}
